export default {
  slug: "dataspell",
  code: "DS",
  label: "DataSpell",
  isIDE: true,
  hasGrid: true,
  // Sergey, 2026-10-31: the Releases banners have no grid.
  noGridChannels: ["releases"],
  krakenDir: "DataSpell",
  thumbnailColor: "#FCF84A",
  // An IDE's logos, not "JetBrains for Data" (Sergey, 2026-11-03).
  logoFamily: "ide",
};
